import React from 'react'
import PropTypes from 'prop-types'
import RateWidgetFooter from 'components/footer'
import DefaultHeader from '../../components/default-header'
import BaseRateTable from '../base'
import styles from './styles.scss'

const FullRateTableDefaultVersion = ({ theme, ...props }) => (
  <div className={styles.fullDefaultRateTableRoot}>
    <DefaultHeader />
    <BaseRateTable {...props} theme={theme} />
    <RateWidgetFooter theme={theme} />
  </div>
)

FullRateTableDefaultVersion.propTypes = {
  theme: PropTypes.string,
}

export default FullRateTableDefaultVersion
